import { Injectable, Injector } from "@angular/core";
import { SERVICE_GLOBAL } from "src/app/shared/constants/services.global";
import { Observable, Subject } from "rxjs";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";

@Injectable({
  providedIn: "root"
})
export class HomeService {
  public serviceGlobal: any;
  private data = new Subject<any>();
  public data$ = this.data.asObservable();
  // private apiKey = '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'
  private readonly apiKey = 'AIzaSyDKe-wuke-yj_szwiUwR0f5bkPi5BUDW6c';
  private readonly streamUrl =
    'https://generativelanguage.googleapis.com/v1beta/models/gemini-2.0-flash:streamGenerateContent?key=' + this.apiKey;


  constructor(private http: HttpClient, private injector: Injector) {
    this.serviceGlobal = this.injector.get(SERVICE_GLOBAL);
  }

  /**
   * @description API call to get home tab data
   * @param entityId Entity ID
   */
  public getHomeData(langCode?: string, defaultUserType?: string): Observable<any> {

    let userType = (defaultUserType) ? defaultUserType : sessionStorage.getItem('userType');
    let lang = (langCode) ? langCode : sessionStorage.getItem("selectedLanguage");
    let region = sessionStorage.getItem('region');
    if (region == 'en-us') {
      return this.http.get(this.serviceGlobal.HOME_DATA)
    }
    else if (lang?.startsWith('en'))
      return this.http.get(this.serviceGlobal.HOME_DATA_EN + '?userType=' + userType)
    else {
      return this.http.get(this.serviceGlobal.HOME_DATA + '?userType=' + userType)
    }
  }

  public submitCaseCreation(obj: any): Observable<any> {
    return this.http.post(this.serviceGlobal.CREATE_CASE, obj);
  }

  /**
 * @description API call to add attachment on submitting a case
 */
  public addAttachmentForCaseCreation(list: any, caseId: any): Observable<any> {
    let url = this.serviceGlobal.ATTACHMENT_UPLOAD + '?caseId=' + caseId;

    return this.http.post(url, list);
  }

  /**
   * @description API call to get the SFDC data
   */
  public getSfdcData(): Observable<any> {
    return this.http.get(this.serviceGlobal.SFDC_DATA);
  }

  /**
   * @description Five9 API to request a call
   * @param url base url
   * @param data form data
   */
  public requestCall(f9CallGroup: any, number: any, data: any): Observable<any> {
    let url = this.serviceGlobal.FIVE9_URL + "?F9CallGroup=" + f9CallGroup + "&number1=" + number;
    if (data.firstName) {
      url = url + '&first_name=' + data?.firstName;
    } if (data.lastName) {
      url = url + '&last_name=' + data?.lastName;
    } if (data.companyName) {
      url = url + '&company=' + data?.companyName;
    } if (data.emailID) {
      url = url + '&email=' + data?.emailID;
    }
    return this.http.post(url, {});
  }

  /**
   * @description API to create the user using idaas api if not registered
   * @param formData Details entered by user
   * @param number Phone number of user
   */
  public createSsoUser(formData: any, number: any): Observable<any> {
    let url = this.serviceGlobal.CREATE_SSO_USER;
    if (formData.firstName) {
      url = url + '?firstName=' + formData?.firstName;
    } if (formData.lastName) {
      url = url + '&lastName=' + formData?.lastName;
    } if (formData.companyName) {
      url = url + '&companyName=' + formData?.companyName;
    } if (formData.emailID) {
      url = url + '&emailId=' + formData?.emailID;
    } if (formData.telephoneNumber) {
      url = url + '&phoneNumber=' + number;
    }
    return this.http.post(url, {});
  }

  /**
   * @description  API to get the user using idaas api
   * @param emailId Email id of user
   */
  public getUser(emailId: string): Observable<any> {
    const url = this.serviceGlobal.GET_USER + '?emailId=' + emailId;
    return this.http.get(url);
  }

  /**
   * API to add the access for service.dnb.com for user who already registered with dnb but no access of service.dnb.com
   * @param emailId Email id of user
   */
  public addProductAccess(emailId: string): Observable<any> {
    const url = this.serviceGlobal.ADD_PRODUCT_ACCESS + '?emailId=' + emailId;
    return this.http.put(url, {});
  }

  /**
  * Method to emit the data from one component to another
  * @param data 
  */
  public emitData(data: any): void {
    this.data.next(data);
  }

  /**
   * @description Case Status API call
   * @param data contain both case number and emailId
   */
  public getCaseStatus(data: any): Observable<any> {
    const caseNumber = data?.isDUNSCheck ? "?" : "?caseNumber=" + data?.caseNumber + "&";
    let url = this.serviceGlobal.GET_CASE_STATUS + caseNumber + "emailID=" + data?.emailID + "&isDUNSCheck=" + data?.isDUNSCheck;
    return this.http.post(url, {});
  }

  /**
   * @description Update Case Status API call
   * @param data contain case number, emailId and isResolved
   */
  public updateCaseStatus(data: any): Observable<any> {
    const body = {
      "caseNotes": data?.reason
    }
    const url = this.serviceGlobal.UPDATE_CASE_STATUS + "?caseNumber=" + data?.caseNumber + "&emailID=" + data?.emailID + "&isResolved=" + data?.isResolved;
    return this.http.post(url, body);
  }
  postSurveyResponse(data: any): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'X-API-TOKEN': 'hXZpQf60LmKKQdY8C7f3RdAMd0kipHbcpbCv977U',
    });
    return this.http.post(this.serviceGlobal.SEND_FEEDBACK, data, { headers });

  }

  streamLLM(prompt: string, onChunk: (chunk: string) => void): void {
    const controller = new AbortController();
    fetch('https://api.openai.com/v1/chat/completions', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.apiKey}`
      },
      body: JSON.stringify({
        model: 'gpt-3.5-turbo', // or gpt-3.5-turbo
        stream: true,
        messages: [{ role: 'user', content: prompt }]
      }),
      signal: controller.signal
    }).then(async response => {
      const reader = response.body?.getReader();
      const decoder = new TextDecoder();
      let done = false;

      while (!done) {
        const { value, done: readerDone } = await reader!.read();
        done = readerDone;
        const chunkValue = decoder.decode(value);
        const lines = chunkValue.split('\n').filter(line => line.trim());

        for (const line of lines) {
          if (line === 'data: [DONE]') return;
          const json = JSON.parse(line.replace(/^data: /, ''));
          const delta = json.choices?.[0]?.delta?.content;
          if (delta) onChunk(delta);
        }
      }
    }).catch(err => {
      console.error('Streaming error', err);
    });
  }
  async streamMessage(prompt: string, onChunk: (text: string) => void, onComplete?: () => void) {
    const body = {
      contents: [{ parts: [{ text: prompt }] }],
    };

    const res = await fetch(this.streamUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });

    if (!res.ok) {
      console.error('Fetch error:', res.statusText);
      return;
    }

    const dataArray = await res.json();
    for (const data of dataArray) {
      const parts = data?.candidates?.[0]?.content?.parts;
      if (parts && parts.length > 0) {
        for (const part of parts) {
          onChunk(part.text);
          await new Promise((resolve) => setTimeout(resolve, 100));
        }
      }
    }

    if (onComplete) onComplete();
  }

  private socket!: WebSocket;

  connect(url: string): void {
    this.socket = new WebSocket(url);
  }

  onMessage(callback: (msg: string) => void): void {
    this.socket.onmessage = (event) => {
      // Parse SSE-like 'data:' lines
      const lines = event.data.split('\n');
      lines.forEach((line: any) => {
        if (line.startsWith('data:')) {
          callback(line.replace('data:', '').trim());
        }
      });
    };
  }

  close(): void {
    this.socket.close();
  }



}
